import { api } from "@/api";
import { ImportedEventBundle } from "./importEvents";

// Provider keys supported by the backend sync endpoint. Must stay in
// sync with `SyncProvider` in sinek-api/src/services/matchImport/syncFromSource.ts.
export type SyncProvider = "scoremer" | "sportradar";

export interface SyncFromSourcePayload {
  provider: SyncProvider;
}

export const syncMatchFromSource = async (
  matchId: string,
  payload: SyncFromSourcePayload
): Promise<ImportedEventBundle> => {
  const res = await api.client.post(
    `/matches/${matchId}/sync-from-source`,
    payload
  );
  return res.data;
};
